export const TEST_ID = 'DetailsViewEntityMenuItem';
